import $ from 'jquery';
import Masonry from 'masonry-layout';


function init() {
  if ($('.projectsDetails__items').length) {
    /* eslint-disable */
    const grid = document.querySelector('.projectsDetails__items');
    const msnry = new Masonry(grid, {
      itemSelector: '.projectsDetails__item',
    });
    /* eslint-enable */
  }
}

module.exports = { init };



/** WEBPACK FOOTER **
 ** ./src/blocks/project_details/project_details.js
 **/